module.exports = __webpack_public_path__ + "static/media/BN.968f7323.png";